export type GravatarOptions = {
  size?: number;
  fallback?: 'blank' | 'initials' | 'mp' | 'identicon' | 'retro' | 'robohash' | '404';
  name?: string;
};

export const getGravatarURL = async (
  email: string,
  { size = 96, fallback = 'blank', name }: GravatarOptions = {}
): Promise<string> => {
  const normalizedEmail = email.trim().toLowerCase();

  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(normalizedEmail));

  const hash = Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');

  const params = new URLSearchParams({
    s: String(size),
    d: fallback,
    r: 'g',
  });

  if (name) params.set('name', name);

  return `https://gravatar.com/avatar/${hash}?${params}`;
};
